import React from 'react'
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

function CustomSpinner({ color }) {
  return (
    <Spin 
      indicator={<LoadingOutlined 
      style={{ fontSize: 24, color: color }} 
      spin />} 
    />
  )
}

export default CustomSpinner
